import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/core/services/api.service';
import { MappingService } from 'app/core/services/mapping.service';
import { ProspectUploadService } from 'app/core/services/prospect-upload.service';
import { UtilService } from 'app/core/services/util.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'prospect-upload-multiway',
    templateUrl: './prospect-upload-multiway.component.html',
    styleUrls: [],
})
export class ProspectUploadMultiwayComponent implements OnInit, OnDestroy {
    progressUnsubscribe: Subscription;
    progressbarLoading: any;
    currentProvider: any = 'chooseSource';
    isMoveCampaign: any;
    profileForm: FormGroup;
    allInputFields: any;
    sortedFields: any = [];
    showHideField: boolean = false;
    isAddProspect: boolean = false;
    @ViewChild('profile') profile: ElementRef;
    currentPath: any;
    @Input() activaPage: 'prospecting' | 'prospect_management' | 'campaign_prospecting' = 'prospecting';
    @Input() isUseDemoData: false;
    isLoadDemo: boolean = false;
    constructor(
        public _prospectService: ProspectUploadService,
        public _mapping: MappingService,
        public _dialog: MatDialog,
        private _api: ApiService,
        private _util: UtilService,
        private _formBuilder: FormBuilder
    ) {
        this.currentPath = window.location.pathname;
        this._mapping.isCustomFieldLoad.subscribe((res: boolean) => {
            if (res == true) {
                this.allInputFields = this._mapping.allInputFields;
                console.log('allInputFields', this.allInputFields);
                this.sortedFields = this._mapping.sortedFields;
                const formGroupConfig = {};
                this.allInputFields.forEach((field) => {
                    const controlName = field.column_key;
                    if (!formGroupConfig[controlName]) {
                        var validators = [];
                        switch (field.column_key) {
                            case 'linkedin':
                                validators.push(
                                    Validators.pattern(
                                        /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?/
                                    )
                                );
                                break;
                            case 'twitter':
                                validators.push(
                                    Validators.pattern(
                                        /^(https?:\/\/)?(www\.)?twitter\.com\/[a-zA-Z0-9_]+\/?$/
                                    )
                                );
                                break;
                            case 'facebook':
                                validators.push(
                                    Validators.pattern(
                                        /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9_]+\/?$/
                                    )
                                );
                                break;
                            case 'website':
                                validators.push(
                                    Validators.pattern(
                                        /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\S*)?$/
                                    )
                                );
                                break;
                            case 'email':
                                validators.push(
                                    Validators.email
                                );
                            default:
                                break;
                        }

                        formGroupConfig[controlName] = ['', validators]; // You can set an initial value if needed
                    }
                });

                this.profileForm = this._formBuilder.group(formGroupConfig);
            }
        });
    }

    ngOnInit(): void {
        this.progressUnsubscribe = this._mapping.isLoadProgress.subscribe(
            (res: boolean) => {
                if (res == true) {
                    this.progressbarLoading = this._mapping.progressbarLoad;
                }
            }
        );
    }

    openSource(type) {
        this.currentProvider = type;
    }

    moveListToCampaign() {
        if (this.isMoveCampaign) return;
        console.log({'campaign_id': this._prospectService.campaignId, 'list_id': this._prospectService.selectedList, 'is_check_duplicate': this._prospectService.isCheckDuplicate});
        this.isMoveCampaign = true;
        const fd = new FormData();
        fd.append('select_all', '1');
        fd.append('campaign_id', this._prospectService.campaignId);
        fd.append('list_id', this._prospectService.selectedList);
        fd.append(
            'is_check_duplicate',
            this._prospectService.isCheckDuplicate == true ? '1' : '0'
        );
        this._api.postData('move-to-campaign', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this._util.showToast(res.message);
                    this._dialog.closeAll();
                    this._prospectService.isMoveProspectLoad.next(true);
                } else {
                    this._util.showToast(res.message, true);
                }
                this.isMoveCampaign = false;
            },
            error: (err) => {
                console.log('err', err);
                this.isMoveCampaign = false;
            },
            complete() {},
        });
    }

    toggleFiledShowHide() {
        this.showHideField = !this.showHideField;
    }

    doAddProspect() {
        if (this.profileForm.invalid || this.isAddProspect) return;
        this.scrollToFirstInvalidControl();
        this.isAddProspect = true;
        const fd = new FormData();
        this.allInputFields.forEach((field) => {
            fd.append(
                field.column_key,
                this.profileForm.controls[field.column_key].value
                    ? this.profileForm.controls[field.column_key].value
                    : ''
            );
        });
      
        fd.append('type', this._mapping.type);
        fd.append('type_id', this._mapping.activeListId);
        this._api.postData('add-prospect-manually', fd).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this._util.showToast(res.message);
                    this._dialog.closeAll();
                    if(window.location.href.includes('/prospect-management')) {
                      this._mapping.isLoadAllCustomers.next(true);
                    } else {
                      this._mapping.isLoadingProspect.next(true);
                    }
                } else {
                    this._util.showToast(res.message, true);
                }
                this.isAddProspect = false;
            },
            error: (err) => {
                console.log('err', err);
                this.isAddProspect = false;
                this.scrollToFirstInvalidControl();
                if (err instanceof Object) {
                    Object.entries(err).forEach(([key, value]) => {
                        switch (key) {
                            case 'email':
                                this.profileForm.controls['email'].setErrors({
                                    lv: value[0],
                                });
                                break;
                        }
                    });
                }
                this.scrollToFirstInvalidControl();
            },
            complete() {},
        });
    }

    scrollToFirstInvalidControl() {
        setTimeout(() => {
            const form = this.profile.nativeElement as HTMLFormElement;
            const invalidControl = form.querySelector('.ng-invalid');
            if (invalidControl) {
                invalidControl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
                console.log('invalidControl', invalidControl);
            }

            console.log({ form: form, invalidControl: invalidControl });
        }, 300);
    }

    ngOnDestroy() {
        if (this.progressUnsubscribe) {
            this.progressUnsubscribe.unsubscribe();
        }
    }

    useDemoData() {
        if(this.isLoadDemo) return;
        this.isLoadDemo = true;
        this._api.getData(`use-demo-data/${this._prospectService.campaignId}`).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this._util.showToast(res.message);
                    this._prospectService.isUploadProspect.next(true);
                    this._dialog.closeAll();
                } else {
                    this._util.showToast(res.message, true);
                }
                this.isLoadDemo = false;
            },
            error: (err) => {
                console.log('err', err);
                this.isLoadDemo = false;
            },
        });
    }
}
